import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as placementActions from './placement.actions';

export function* getIndentsList(params) {
  const request = api.indentsListRequest.bind(null, params);
  yield fetchEntity(request, placementActions.getIndentsList, params);
}

export function* getEmailsList(params) {
  const request = api.getEmailsListRequest.bind(null, params);
  yield fetchEntity(request, placementActions.getEmailsList, params);
}
export function* getDistrictOrigins(params) {
  const request = api.getDistrictOriginRequest.bind(null);
  yield fetchEntity(request, placementActions.getDistrictList, params);
}

export function* assignIndent(payload) {
  const request = api.assignIndentRequest.bind(null, payload);
  yield fetchEntity(request, placementActions.assignIndent, payload);
}

export function* getHeaderDetails(params) {
  const request = api.getHeaderDetailsRequest.bind(null, params);
  yield fetchEntity(request, placementActions.getHeaderDetails, params);
}

export function* viewFreight(params) {
  const request = api.viewFreightRequest.bind(null, params);
  yield fetchEntity(request, placementActions.viewFreight, params);
}

export function* fetchExpireReason(params) {
  const request = api.fetchExpireReasons.bind(null, params);
  yield fetchEntity(request, placementActions.fetchExpireReason, params);
}

export function* getConsignerCodes(payload) {
  const request = api.getConsignerSuggestionsRequest.bind(null, payload);
  yield fetchEntity(request, placementActions.getConsignerCodes, payload);
}

// export function* updateBasicDetails(payload) {
//   const request = api.updateOperatorRequest.bind(null, payload);
//   yield fetchEntity(request, operatorActions.updateBasicDetails, payload);
// }

// export function* operatorStatus() {
//   const request = api.operatorStatusRequest.bind();
//   yield fetchEntity(request, operatorActions.operatorStatus, null);
// }

/* ************* WATCHERS ************ */

// export function* watchOperatorStatusSaga() {
//   while (true) {
//     yield take(operatorActions.GET_OPERATOR_STATUS[REQUEST]);
//     yield fork(operatorStatus);
//   }
// }

export function* watchGetIndentsListSaga() {
  while (true) {
    const { params } = yield take(placementActions.GET_INDENTS_LIST[REQUEST]);
    yield fork(getIndentsList, params);
  }
}

export function* watchGetEmailsListSaga() {
  while (true) {
    const { params } = yield take(placementActions.GET_EMAILS_LIST[REQUEST]);
    yield fork(getEmailsList, params);
  }
}
export function* watchGetDistrictListSaga() {
  while (true) {
    const { params } = yield take(placementActions.GET_DISTRICT_LIST[REQUEST]);
    yield fork(getDistrictOrigins, params);
  }
}

export function* watchAssignIndentSaga() {
  while (true) {
    const { payload } = yield take(placementActions.ASSIGN_INDENT[REQUEST]);
    yield fork(assignIndent, payload);
  }
}

export function* watchGetHeaderDetailsSaga() {
  while (true) {
    const { params } = yield take(placementActions.GET_HEADER_DETAILS[REQUEST]);
    yield fork(getHeaderDetails, params);
  }
}

export function* watchViewFreightApprovalSaga() {
  while (true) {
    const { params } = yield take(placementActions.VIEW_FREIGHT[REQUEST]);
    yield fork(viewFreight, params);
  }
}

export function* watchFetchExpireReasons() {
  while (true) {
    const { params } = yield take(placementActions.FETCH_EXPIRE_REASON[REQUEST]);
    yield fork(fetchExpireReason, params);
  }
}

export function* watchGetConsignerCodesSaga() {
  while (true) {
    const { payload } = yield take(placementActions.GET_CONSIGNER_CODES[REQUEST]);
    yield fork(getConsignerCodes, payload);
  }
}
